import basketSummary from './mini_basket.template.html';

angular.module('bl.basket').component('blMiniBasket', {
  controller: ['$scope', '$rootScope', '$location', '$anchorScroll', miniBasketController],
  controllerAs: '$miniBasketCtrl',
  templateUrl: basketSummary.id,
  bindings: {
    bblocation: '=',
  }
});

function miniBasketController($scope, $rootScope, $location, $anchorScroll) {
  this.basket = [];
  const self = this;
  $scope.$on('basket:updated', function (event, basket) {
    // remove all basket.items that contain is_coupon: true.
    self.basket = basket.items.filter(item => !item.is_coupon);
  });

  $scope.$on('basket-items', function (event, basket) {
    // remove all basket.items that contain is_coupon: true.
    self.basket = basket.items.filter(item => !item.is_coupon);
  });

  this.scrollToBasket = () => {
    if (this.bblocation != 'public-booking/_templates/steps/event') {
      $scope.$parent.$parent.showPage('public-booking/_templates/steps/basket_summary');
    }
  }
}


// WEBPACK FOOTER //
// src/public/javascripts/basket/mini-basket/mini_basket.component.js